import { render, staticRenderFns } from "./KindSelect.vue?vue&type=template&id=6611f7ee"
import script from "./KindSelect.vue?vue&type=script&lang=ts"
export * from "./KindSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports